const ALL_EMPLOYEES_VALUE = "__all__";

export default ALL_EMPLOYEES_VALUE;
